export default __webpack_public_path__ + "static/media/rubberized-black.32c8a853.jpeg";